import { render } from "./Mastercard.vue?vue&type=template&id=50f04a34"
import script from "./Mastercard.vue?vue&type=script&lang=js"
export * from "./Mastercard.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "50f04a34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50f04a34', script)) {
    api.reload('50f04a34', script)
  }
  
  module.hot.accept("./Mastercard.vue?vue&type=template&id=50f04a34", () => {
    api.rerender('50f04a34', render)
  })

}

script.__file = "src/icons/components/logos/Mastercard.vue"

export default script